export type AutoScheduleTabId = 'requirements' | 'districts' | 'copy'

export type AutoScheduleFlags = {
  requirements: boolean
  districts: boolean
  copy: boolean
}

const isEnabled = (viteValue: string | undefined, runtimeValue: string | undefined): boolean =>
  viteValue === 'true' || runtimeValue === 'true'

export const readAutoScheduleFlags = (
  env: {
    VITE_AUTO_SCHEDULE_REQUIREMENTS?: string
    VITE_AUTO_SCHEDULE_DISTRICTS?: string
    VITE_AUTO_SCHEDULE_COPY?: string
  },
  runtime?: {
    AUTO_SCHEDULE_REQUIREMENTS?: string
    AUTO_SCHEDULE_DISTRICTS?: string
    AUTO_SCHEDULE_COPY?: string
  }
): AutoScheduleFlags => ({
  requirements: isEnabled(env.VITE_AUTO_SCHEDULE_REQUIREMENTS, runtime?.AUTO_SCHEDULE_REQUIREMENTS),
  districts: isEnabled(env.VITE_AUTO_SCHEDULE_DISTRICTS, runtime?.AUTO_SCHEDULE_DISTRICTS),
  copy: isEnabled(env.VITE_AUTO_SCHEDULE_COPY, runtime?.AUTO_SCHEDULE_COPY),
})

export const getAutoScheduleFlags = (): AutoScheduleFlags =>
  readAutoScheduleFlags(import.meta.env, typeof window !== 'undefined' ? window.ENV : undefined)

export const isAutoScheduleAvailable = (flags: AutoScheduleFlags = getAutoScheduleFlags()): boolean =>
  flags.requirements || flags.districts || flags.copy

export const visibleAutoScheduleTabs = (flags: AutoScheduleFlags, hasBillingPeriod: boolean): AutoScheduleTabId[] => {
  const tabs: AutoScheduleTabId[] = []
  if (flags.requirements && hasBillingPeriod) {
    tabs.push('requirements')
  }
  if (flags.districts) {
    tabs.push('districts')
  }
  if (flags.copy) {
    tabs.push('copy')
  }
  return tabs
}
